import { useQuery } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { IQueryResponse } from '@services/api';
import { CMDIDropdownRBDMItem } from './cmdiDropdownRBDM';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { setRxdb } from '@helper/utils';
import { ProfileData } from '../profile';
import { useGetRxDb } from '@hooks/getRxdbData';

export const useCMDIDropdownRBDMQuery = (): IQueryResponse<CMDIDropdownRBDMItem[]> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('mdi_code_list');
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	// Check if profile is loaded and user is not RBDM
	const isProfileLoaded = profile && profile.length > 0;
	const userRole = profile[0]?.usertype_c;
	const isRBDM = userRole === 'RBDM';
	const shouldEnableQuery = isProfileLoaded && isRBDM && isDbChecked && shouldFetch;

	const fetchCMDIDropdownRBDM = async (): Promise<CMDIDropdownRBDMItem[]> => {
		const response = await APIService.getData<CMDIDropdownRBDMItem[]>(APICONFIG.CMDI_DROPDOWN_RBDM, {
			limit: '0',
		});

		if (response && response.length > 0) {
			await setRxdb('mdi_code_list', response);
		}

		return response;
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['cmdi-dropdown-rbdm'],
		queryFn: fetchCMDIDropdownRBDM,
		enabled: shouldEnableQuery,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
